import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class SelectButton extends Component {
  constructor(props) {
    super(props);
  }
    
  render() {
    const { t } = this.props;

    let btnClass = 'fe-u-select-btn';
    let btnStr = t('form:select');
    if(this.props.disabled) {
      btnClass = btnClass.concat(' unavailable');
      btnStr = t('form:unavailable');
    } else if(this.props.selected) {
      btnClass = btnClass.concat(' selected');
      btnStr = t('form:selected');
    }

    return (
      <button
        type="button"
        onClick={this.props.onClick}
        className={btnClass}
        disabled={this.props.disabled}
      >
        {btnStr}
      </button>
    );  
  }
}

export default withTranslation()(SelectButton);

SelectButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedId: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

SelectButton.defaultProps = {
  selected: false,
  disabled: false,
};